import React, {Component} from "react";
import {changeState, formatPrice, formatTime, relativePath, saveMessage, sortTable} from "../lib/tools";
import {Route, Switch} from "react-router-dom";
import {Checkbox} from "../components/common/formValidation";
import {Button, SortedTable} from "../components/common/common";
import {reduxWrapper} from "../globalState";

const OrderTool = (props) => (
    <div id="orderTool">
	    <Switch>
		    <Route path="*/orders/:orderId" render={({match: {params: {orderId}}}) => <OrderView orderId={orderId} />} />
		    <Route render={() => <OrderOverview/>}/>
	    </Switch>
    </div>
);

class OrderOverviewRender extends React.Component {
    state = {
    	orders: []
    };
	
	componentWillMount() {
		this.props.apiCall("GET", `/admin/orders`, orders => {
			this.orders = orders;
			this.setState({orders});
		}, {simple: true, isPaid: true})
	}
	
	tableChange({order = "id", orderAsc = true, ...rest}) {
		this.setState({orders: sortTable(this.orders, this.columns, order, orderAsc)});
	}
	
	columns = {
		id: {
			name: "ID",
			sortable: true
		},
		createdAt: {
			name: "Dato",
			sortable: true,
			render: formatTime
		},
		name: {
			name: "Navn",
			sortable: true
		},
		isPaid: {
			name: "Paid",
			sortable: true,
			render: val => val ? "Yes" : "No"
		},
		isInvoiced: {
			name: "Sent",
			sortable: true,
			render: val => val ? "Yes" : "No"
		},
		total: {
			name: "Total",
			sortable: true,
			render: formatPrice
		}
	};
    
    render() {
        return (
            <div className="orders">
	            <SortedTable
		            columns={this.columns}
		            rows={this.state.orders}
		            history={this.props.history}
		            redirect={relativePath("") + "/"}
		            onChange={val => this.tableChange(val)}
		            pages={false}
		            redirectProp="id"/>
            </div>
        );
    }
}

const OrderOverview = reduxWrapper("getApiCall")(OrderOverviewRender);


class OrderViewRender extends React.Component {
    constructor(props) {
        super(props);
        
        this.onCapture = () => {
            props.apiCall("POST", `admin/order/${this.props.orderId}/capture`, data => {
            	this.setState(changeState(["order", "isInvoiced"], true));
	            this.props.sendMessage(saveMessage())
            })
        };
    }
    
    state = {
    	order: {
    		products: [],
		    user: {},
		    mainAddress: {},
		    shipping: []
	    }
    };
    
    componentWillMount() {
        this.props.apiCall("GET", `/admin/order/${this.props.orderId}`, order => this.setState({order}))
	}
    
    render() {
    	const {order: {mainAddress: {address, city, zipcode}, user: {name, email, phone}, products, shipping, shippingTotal, isPaid, total, isInvoiced}} = this.state;
    	
        return (
        	<div className="container">
		        <div className="info">
			        <h2>Info</h2>
			        <Checkbox value={isPaid} title="Is paid"/>
			        <Checkbox value={isInvoiced} title="Invoice sent"/>
		        </div>
		        <div className="user">
			        <h2>User</h2>
			        <p className="name">{name}</p>
			        <p className="email">{email}</p>
			        <p className="phone">{phone}</p>
		        </div>
		        <div className="address">
			        <h2>Address</h2>
		            <p className="address">{address}</p>
		            <p className="city">{city}, {zipcode}</p>
		        </div>
		        <div className="products">
			        <h2>Products</h2>
			        {products.map((x, i) => <OrderItem key={i} {...x}/>)}
		        </div>
		        <div className="shipping">
			        <h2>Shipping</h2>
			        {shipping.map((x, i) => (
				        <p className="shipping" key={i}><b>{x.vendorName}:</b> {x.shippingName} - {formatPrice(x.shippingPrice)}</p>
			        ))}
			        <p className="total">SHIPPING: {formatPrice(shippingTotal)}</p>
		        </div>
		        <div className="total">
			        <h2>Total</h2>
			        <p className="total">TOTAL: {formatPrice(total)}</p>
		        </div>
		        <div className="actions">
			        <h2>Actions</h2>
			        {isInvoiced ? null : <Button onClick={this.onCapture}>Take Money</Button>}
		        </div>
	        </div>
        );
    }
}

const OrderView = reduxWrapper("getApiCall", "getSendMessage")(OrderViewRender);

class OrderItem extends Component {
	state = {checked: false};
	
	render() {
		let {name, qtyOrdered: qty, url, configurations = [], customOptions = []} = this.props;
		
		return (
			<div className="orderItem">
				<Checkbox title="" value={this.state.checked} onChange={checked => this.setState({checked})}/>
				<div className="verticalWrapper">
					<p className="name">{name}</p>
					<div className="info">
						<p className="qty">{qty}</p>
						{url && <a href={url} target="_blank" className="url">Til Produkt</a>}
					</div>
					{configurations.length > 0 && <p className="big">Configurable Options:</p>}
					{configurations.map((x, i) => <p className="conf" key={i}>{x.name}: {x.value}</p>)}
					{customOptions.length > 0 && <p className="big">Custom Options:</p>}
					{customOptions.map((x, i) => <p className="custom" key={i}>{x.name}: {x.value}</p>)}
				</div>
			</div>
		);
	}
}

export default OrderTool;


// WEBPACK FOOTER //
// ./src/admin/orderTool.js